import { createLogic } from 'redux-logic';

import { ERROR_ACCOUNT_VISIBILITY } from 'state/preferences/PreferencesActions'
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';

const FailedAccountVisibilityLogic = createLogic({
  type: [ERROR_ACCOUNT_VISIBILITY],

  process({ action }, dispatch, done) {
    // dispatch user message
    const title = '';
    const message =
      'Unfortunately, we were unable to save the changes to your account view settings due to an error in our processes. Please try again later.';
    dispatch(addToast(false, title, message));

    // dispatch analytics message
    dispatch(analyticsActionError(action.type));

    done();
  }
});

export default FailedAccountVisibilityLogic;